
<template>
  <div
    class="bg"
    :style="{
      backgroundImage:
        'url(' + (activeInfo.actSignInImg && activeInfo.actSignInImg) + ')',
      backgroundSize: 'cover',
    }"
  >
    <van-nav-bar :title="source == 0 ? actName + '在线签到' : '完善报名信息'">
      <template #right>
        <img src="../assets/img/timg.jpg" alt class="avaterImg" />
      </template>
    </van-nav-bar>
    <van-popup
      v-model="showSuccess"
      style="width: 85%; padding: 10px; border-radius: 5px"
    >
      <div class="infoMsg">
        <img src="../assets/img/success.png" alt="" />
        <p>{{ source == 0 ? '提交' : '报名' }}成功！</p>
        <div style="margin: 16px">
          <van-button
            v-if="source == 0"
            round
            block
            type="info"
            @click="closePage"
            >关闭</van-button
          >
          <van-button
            v-if="source != 0"
            round
            block
            type="info"
            @click="backPage"
            >确认</van-button
          >
        </div>
      </div>
    </van-popup>
    <van-form @submit="onSubmit">
      <div class="formBg">
        <van-field
          v-for="(item, index) in dataForm"
          :key="item.attId"
          v-model="obj[item.attId]"
          :name="item.attId"
          :label="item.attName"
          :required="item.attStatus === 1 ? true : false"
          :placeholder="'请输入' + item.attName"
          :rules="[rules[index], rules2[index]]"
        />
      </div>
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataForm: {},
      actId: 0,
      rules: [],
      rules2: [],
      obj: {},
      actName: '',
      showSuccess: false,
      activeInfo: {},
      userId: this.$route.query.userId || 0,
      source: this.$route.query.source || 0,
      type: this.$route.query.type || 0,
      liveId: this.$route.query.liveId,
    }
  },
  mounted() {
    var url = window.location.href
    var cs = url.split('?')[1] //?后面的参数字符串
    var cs_arr = cs.split('&') //将参数字符串分割为包含多个参数的数组
    var cs = {} //声明一个容器
    for (var i = 0; i < cs_arr.length; i++) {
      //遍历数组
      cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
    }

    this.actId = Number(cs.actId)
    if (this.source === 0) {
      this.actId = Number(this.$route.query.actId)
    }

    this.getActiveInfo()
    this.getActivityName()

    this.getInfo()
  },
  methods: {
    // 关闭页面
    closePage() {
      WeixinJSBridge.call('closeWindow')
    },
    // 返回上一个页面
    backPage() {
      if (this.type === 0) {
        // type=0，表示是从app进来的，走app返回上一页的方法
        android.setResult()
      } else if(this.type === 1){
        // type=1，是公众号进来的，走路由
        this.$router.go(-1)
      } else {
    	  // type=2，ios进来的
    	  window.webkit.messageHandlers.iosNavigationPop.postMessage(null);
      }
    },
    getActivityName() {
      this.$http({
        url: `/act/activity/info/${this.actId}`,
        method: 'get',
        params: {},
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.actName = data.data.actName
        }
      })
    },
    getActiveInfo() {
      this.$http({
        url: `/act/activity/info/${this.actId}`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.activeInfo = data.data
        }
      })
    },
    getActivityName() {
      this.$http({
        url: `/act/activity/info/${this.actId}`,
        method: 'get',
        params: {},
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.actName = data.data.actName
        }
      })
    },
    getInfo() {
      this.$http({
        url: '/act/attribute/userSign',
        method: 'get',
        params: { actId: this.actId },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm = data.data
          for (let i = 0; i < this.dataForm.length; i++) {
            this.dataForm[i].attId = this.dataForm[i].attId.toString()
            if (this.dataForm[i].attStatus === 1) {
              let msg = this.dataForm[i].attName + '不能为空'
              if (
                this.dataForm[i].regex != null &&
                this.dataForm[i].regex != ''
              ) {
                this.rules2.push({
                  pattern: new RegExp(this.dataForm[i].regex),
                  message: '请输入正确的' + this.dataForm[i].attName,
                })
              } else {
                this.rules2.push({})
              }
              this.rules.push({ required: true, message: msg })
            } else {
              if (
                this.dataForm[i].regex != null &&
                this.dataForm[i].regex != ''
              ) {
                this.rules2.push({
                  pattern: new RegExp(this.dataForm[i].regex),
                  message: '请输入正确的' + this.dataForm[i].attName,
                })
              } else {
                this.rules2.push({})
              }
              this.rules.push({ required: false, message: '' })
            }
          }
        }
      })
    },
    onSubmit(values) {
      let data = {}
      data.actId = this.actId
      data.userId = this.userId
      data.liveId = this.liveId
      data.signs = []
      for (let key in values) {
        data.signs.push({ attId: Number(key), attValue: values[key] })
      }
      this.$http({
        url: '/act/signin/save',
        method: 'post',
        data: data,
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (this.type === 1) {
             this.signUp()
          } else {
        	 this.showSuccess = true
             this.obj = {}
          }
        } else {
          this.$toast(data.msg)
        }
      })
    },
    signUp() {
      this.$http({
        url: `/client/live/signUp/${this.liveId}`,
        method: 'post',
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          // this.$toast('报名成功!')
          this.showSuccess = true
          this.obj = {}
        } else {
          this.$toast('报名失败，请稍后再试')
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.formBg {
  padding: 10px;
  border-radius: 5px;
  background-color: #fff;
  margin: 10px;
}
.bg {
  min-height: 100vh;
}
.avaterImg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
/deep/.van-form {
  margin: 30px 10px 0;
}
.infoMsg {
  text-align: center;
  padding-top: 50px;
  p {
    padding: 10px;
    margin: 0 20px;
    border-radius: 10px;
    text-align: center;
    margin-top: 20px;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
/deep/.van-field__control {
font-size: 16px;

}
</style>